import moment, { CalendarSpec } from 'moment';

type humanReadableType = 'notifications' | 'history';

export const getDateFormat = (type: humanReadableType, t) => {
  const yesterday = t('T.MOMENT Yesterday');
  const today = t('T.MOMENT Today');
  const tomorrow = t('T.MOMENT Tomorrow');

  switch (type) {
    case 'notifications':
    default:
      return {
        lastWeek: 'DD MMMM',
        lastDay:  `[${yesterday}]`,
        sameDay:  `[${today}]`,
        nextDay:  `[${tomorrow}]`,
        nextWeek: 'DD MMMM',
        sameElse: 'DD MMMM'
      };
    case 'history':
      return {
        lastWeek: 'ddd DD/MM, HH:mm',
        lastDay:  `[${yesterday}], HH:mm`,
        sameDay:  `[${today}], HH:mm`,
        nextDay:  `[${tomorrow}], HH:mm`,
        nextWeek: 'ddd DD/MM, HH:mm',
        sameElse: 'ddd DD/MM, HH:mm'
      };
  }
};

export const humanReadableFormat = (
  date: string | Date,
  t,
  type: humanReadableType = 'notifications',
  formats: CalendarSpec = {}
): string => {
  const definedFormats = getDateFormat(type, t);

  return moment(date)
    .calendar(undefined, {
      ...definedFormats,
      ...formats
    });
};

export const humanReadableHoursFormat = (date: string | Date, t) => {
  const duration = moment.duration(
    moment()
      .diff(moment(date))
  );

  const seconds = Math.floor(Math.abs(duration.asSeconds()));
  const minutes = Math.floor(Math.abs(duration.asMinutes()));
  const hours = Math.floor(Math.abs(duration.asHours()));

  if (minutes === 0) {
    return t('%ds')
      .replace('%d', seconds);
  }
  if (hours === 0) {
    return t('%dm')
      .replace('%d', minutes);
  }
  if (hours < 24) {
    return t('%dh')
      .replace('%d', hours);
  }

  return moment(date)
    .format('DD/MM/YY');
};
